"use strict";
import s from "underscore.string";
import _ from "underscore";
import ReactCursor from "./util/react/cursor";
import classNames from "classnames";
export default {
  cursor: ReactCursor,
  makeBem: function(bemRoot) {
    return function bem(...args) {
      if (arguments.length === 0) {
        return bemRoot;
      } else {
        return _.chain(arguments).map(function(stringOrObject) {
          if (_.isObject(stringOrObject)) {
            return classNames(
              _.reduce(
                stringOrObject,
                function(newObject, shouldDisplay, bemString) {
                  newObject[bem(bemString)] = shouldDisplay;
                  return newObject;
                },
                {}
              )
            );
          } else if (_.isEmpty(stringOrObject)) {
            return bemRoot;
          } else if (s.startsWith(stringOrObject, "__")) {
            if (s.include(stringOrObject, "--")) {
              var parts = stringOrObject.split("--");
              return [
                bemRoot + parts[0],
                bemRoot + parts[0] + "--" + parts[1]
              ];
            } else {
              return bemRoot + stringOrObject;
            }
          } else if (s.startsWith(stringOrObject, "--")) {
            return [bemRoot, bemRoot + stringOrObject];
          } else {
            return stringOrObject;
          }
        }).flatten().uniq().value().join(" ");
      }
    };
  }
};
